
    <div style="min-height:157px;;text-align:center;margin:10% 20% 10% 20%;"
        class=" col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <h3>Unauthorized</h3>
        <div >
            <button type="button" class="btn btn-primary btn-add" [routerLink]="['/admin']">
                                    Back To Dashboard
                                    </button>
        </div>

    </div>
  




// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/views/app-unauthorized.component.html